import gql from "graphql-tag";

export const DOWNLOAD_REPORT_QUERY = gql`
query reportDownloadDownloadReportQuery($tool_id: ID!, $response_id: ID!) {
  exportSurveyPdf(toolId: $tool_id, responseId: $response_id)
}
`

export const DOWNLOAD_REPORT_SUBSCRIPTION = gql`
subscription reportDownloadDownloadReportSubscription{
  downloadReportSubscription{
    mutation
    filePath
    taskId
  }
}
`